import { getLinks } from '@cinch-nx/data-storyblok'
import { GetStaticPathsResult } from 'next/types'
import { jargonStaticPaths } from './data/jargon-feature-data'
import { AcceptedLinksStarts } from '@cinch-nx/data-storyblok'

export const getStaticPathsGenerator =
  (slug: string) => async (): Promise<GetStaticPathsResult> => {
    // Get the paths we want to pre-render based on data
    try {
      const links = await getLinks(slug as AcceptedLinksStarts)
      const paths = jargonStaticPaths({ links })
      return { paths, fallback: 'blocking' }
    } catch {
      return { paths: [], fallback: 'blocking' }
    }
  }
